import React from "react";
import {useTranslation} from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import {Dialog, DialogContent} from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import MDButton from "../../../materialDashboard/components/MDButton";
import MDLoadingButton from "../../../components/MDLoadingButton";
import DialogActions from "@mui/material/DialogActions";
import {useModel23ExportMutation} from "../query";
import useYetizSnowProfileDownload from "../../../components/Graph/YetizSnowProfile/useYetizSnowProfileDownload";


const DownloadDialog = ({model23, onClose}) => {
    const {t} = useTranslation(["models23"]);
    const [type, setType] = React.useState('mod4');
    const [loading, setLoading] = React.useState(false);

    const model23Export = useModel23ExportMutation();
    const yetizAinevaProfileDownload = useYetizSnowProfileDownload();

    const handleTypeChange = (event) => {
        setType(event.target.value);
    }

    const handleDownload = async () => {
        setLoading(true);
        if (type === 'x23') {
            await model23Export.mutateAsync({id: model23.id, format: 'X23'});
            onClose();
        } else if (type === 'caamlv6') {
            await model23Export.mutateAsync({id: model23.id, format: 'CAAML'});
            onClose();
        } else {
            // Default to mod4
            await yetizAinevaProfileDownload.handleDownload(model23);
            onClose();
        }
        setLoading(false);
    }

    return <Dialog onClose={onClose} open={true} maxWidth="sm" fullWidth>
        <DialogTitle>{t('download.title')}</DialogTitle>
        <DialogContent>
            <FormControl fullWidth>
                <RadioGroup
                    name="asyncExport"
                    value={type}
                    onChange={handleTypeChange}>
                    <Grid container>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Radio/>}
                                label={t('download.mod4')}
                                value='mod4'
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Radio/>}
                                label={t('download.x23')}
                                value='x23'
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Radio/>}
                                label={t('download.caamlv6')}
                                value='caamlv6'
                            />
                        </Grid>
                    </Grid>
                </RadioGroup>
            </FormControl>
        </DialogContent>
        <DialogActions>
            <MDButton onClick={onClose} color="info" variant="outlined">
                {t('download.cancel')}
            </MDButton>
            <MDLoadingButton onClick={handleDownload}
                             loading={loading}
                             color="info"
                             variant="gradient">
                {t('download.download')}
            </MDLoadingButton>
        </DialogActions>
    </Dialog>
}

export default DownloadDialog;